module.exports = ".warning {\n  background-color: #ff8f00 !important;\n  color: #ffffff !important;\n}\n\n.exceeded {\n  background-color: #0165b1 !important;\n  color: #ffffff !important;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/user/user.component.css
// module id = ./src/app/user/user.component.css
// module chunks = main